import { memo, useEffect, useMemo, useState } from 'react';
import styles from './detail.module.scss';
import { DetailSellProps } from '../../../interfaces/salePost';
import { useNavigate } from "react-router-dom";
import { OpenModalProps } from "../../../interfaces/components";
import { caracteristics, conforts as confortsImages, images } from '../../../constants/images';
import { MODAL_SELL_TEXTS } from "../../../constants/offers";
import ButtonShared from '../../../components/Button';
import Button from '../../../components/Button';
import Modal from "../../../components/Modal";
import PublicationDetailRefactored from '../../../components/PublicationDetail/';
import { useToast } from '../../../helpers/hooks';
import { capitalize } from '../../../helpers/app';
import SuggestedPrices from '../../../components/SuggestedPrices';
import { useLocation } from 'react-router-dom';

const Detail = ({
    user,
    salePost,
    clearPostFetching,
    clearSalePost,
    postPublication,
    setLoginRedirection,
    selectedAdditionalCharacters
}: DetailSellProps) => {
    const location = useLocation();
    const toast = useToast();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<OpenModalProps>({ open: false, type: "accepted" });
    const [timeOutMessage, setTimeOutMessage] = useState<any>({open: false, text: ""});

    const handlePressBack = () => {
        localStorage.setItem('linzeReturnFromDetail', 'true');
        navigate(-1);
      };

    const handlePressPublish = () => {
        if(!user){
            toast("Debes iniciar sesión");
            setLoginRedirection("/sell/detail");
            navigate("/login");
            return;
        }
        setLoading(true);
        setTimeOutMessage({open: true, text: `Publicando`});
        postPublication();
    }

    const onCloseModal = () => {
        clearPostFetching();
        if (salePost?.fetchingPostPublication === "failure") {
            return setOpenModal({...openModal, open: false});
        }
        setOpenModal({...openModal, open: false});
        clearSalePost();
        navigate("/profile/my_publications", { state: { activeTab: salePost?.vin ? "new" : "used" } });
    };

    const publicationNormalized: any = useMemo(() => {
        const conforts = salePost?.confort && salePost?.confort.map((item: any) => (
            {
                name: item?.label,
                value: item?.isSelected ? "Si" : "No",
                icon: confortsImages[item?.id] ?? ""
            }
        ));
        let publicationObject = {
            pictures: salePost?.imagesVideos.filter((image: any) => image.uri ?? image.url ?? image.previewURL ?? image),
            title: `${salePost.brands.selected?.label} ${salePost.models.selected?.label}`,
            year: salePost?.years.selected,
            mileage: salePost?.kms,
            region: salePost?.region,
            price: salePost?.price,
            chatgpt_description: salePost?.price?.descriptionGPT?.data,
            confort: conforts,
            vin: salePost?.vin,
            tags: salePost?.tags,
            record: salePost?.record,
            additional_characters: selectedAdditionalCharacters,
            detail: {
                ...salePost?.record,
                negotiate: salePost?.negotiatePrice,
                bonus_info: {
                  bonus: salePost?.financingBonus,
                  value: 0
                },
                negotiate_percentage: salePost?.negotiatePercentage
              },
              percentage: salePost?.negotiatePercentage,
            version: (salePost?.version?.id !== 0 && salePost?.version?.id !== 1) ? salePost?.version?.name : null,
            suggestedPrice: salePost?.suggestedPrices,
            caracteristics: [
                {
                    name: "Modelo",
                    value: salePost.models.selected?.label,
                    icon: caracteristics.model
                },
                {
                    name: "Año",
                    value: salePost?.years.selected,
                    icon: caracteristics.year
                },
                {
                    name: "Versión",
                    value: salePost?.version?.name,
                    icon: caracteristics.version
                },
                {
                    name: "Color",
                    value: capitalize(salePost?.color),
                    icon: caracteristics.color
                },
                {
                    name: "Combustible",
                    value: capitalize(salePost?.fuel),
                    icon: caracteristics.fuel
                },
                {
                    name: "Puertas",
                    value: salePost?.doors,
                    icon: caracteristics.door
                },
                {
                    name: "Transmisión",
                    value: capitalize(salePost?.transmission),
                    icon: caracteristics.transmission
                },
                {
                    name: "Carrocería",
                    value: capitalize(salePost?.vehicle_type),
                    icon: caracteristics.type
                }
            ],
            records: [
                {
                    name: "Negociación",
                    value: salePost?.negotiatePrice ? "El vendedor está dispuesto a negociar" : "El vendedor no está dispuesto a negociar",
                    icon: caracteristics.consultation
                },
                {
                    name: "Accidentes reportados",
                    value: salePost?.record?.accidentsReported ? "Con accidentes reportados" : "Sin accidentes reportados",
                    icon: caracteristics.accidents
                },
                {
                    name: "Uso personal",
                    value: salePost?.record?.personalUse ? "Vehículo de uso personal" : "Vehículo de uso comercial",
                    icon: caracteristics.usage
                },
                {
                    name: "Dueño único",
                    value: salePost?.record?.soleOwner ? "Único dueño" : "Multiples dueños",
                    icon: caracteristics.accountant
                }
            ],
            iva: salePost?.iva,
        }
        return publicationObject;
    }, [salePost]);


    useEffect(() => {
        if (salePost?.fetchingPostPublication === "failure") {
            setLoading(false);
            setOpenModal({type: "rejected", open: true});
            setTimeOutMessage({...timeOutMessage, open: false});
        }
        if (salePost?.fetchingPostPublication === "success") {
            setLoading(false);
            // setOpenModal({type:salePost.publicationPublishedStatus === "pending" ? "pending" : "accepted", open: true});
            setTimeOutMessage({...timeOutMessage, open: false});
            if (salePost?.fetchingPostPublication === "success") {
                setLoading(false);
                setTimeOutMessage({ ...timeOutMessage, open: false });
                clearSalePost();
                navigate("/profile/my_publications?published=success", {
                    state: { activeTab: salePost?.vin ? "new" : "used" }
                });
            }
        }
    }, [salePost?.fetchingPostPublication]);

    useEffect(() => {
        if(!salePost?.plate){
            if(!salePost?.vin){
                navigate("/sell");
            }
        }
    }, []);

    
    return (
        <div className={styles.container}>
            <Modal open={openModal.open} onClose={onCloseModal} variant='white'>
                <div className={styles.modalPublicationContainer}>
                    {["accepted","pending"].includes(openModal?.type) && <img alt="success" src={images.purpleRoundCheckmark} width={120}/>}
                    <p className={styles.title}>{MODAL_SELL_TEXTS[openModal.type].title}</p>
                    <p className={styles.description}>{MODAL_SELL_TEXTS[openModal.type].description}</p>
                    <Button onPress={onCloseModal} title={MODAL_SELL_TEXTS[openModal.type].button} primary />
                </div>
            </Modal>
            <PublicationDetailRefactored
                type="salePost"
                publication={publicationNormalized}
                typeCar={location.state?.type}
            >
                {
                    <>
                        <ButtonShared 
                            onPress={handlePressBack}
                            title="Volver a editar" 
                            tertiary
                            className={styles.back} 
                            disabled={loading}
                            size="small"
                        />
                        <ButtonShared 
                            size="small"
                            onPress={handlePressPublish}
                            title="Publicar" 
                            primary
                            className={styles.publish} 
                            loading={loading}
                        />
                    </>
                }
                <div className={`${styles.timeOut} ${timeOutMessage?.open && styles.show}`}>
                    <p className={styles.loader}>
                        {timeOutMessage?.text}
                        <span className={styles.dotOne}>.</span>
                        <span className={styles.dotTwo}>.</span>
                        <span className={styles.dotThree}>.</span>
                    </p>
                </div>
            </PublicationDetailRefactored>
        </div>
    )
}

export default memo(Detail);